import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddGalleryCategory = () => {

  const navigate = useNavigate();

  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await apiFetch("leader_admin/insert_gallery_categories", {
        method: "POST",
        body: JSON.stringify({ name: categoryName }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      alert("गॅलरी विभाग यशस्वीरित्या जोडला गेला");
      navigate("/all_gallery_category");

    } catch (error) {
      console.error(error);
      alert(error.message || "त्रुटी आली");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                📂 गॅलरी विभाग जोडा (Add Gallery Category)
              </h4>
              <small className="text-white-50">Create a new category for photo gallery</small>
            </div>
          </div>

          <Link to="/all_gallery_category" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Category List
          </Link>
        </div>

        {/* Form Card */}
        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    विभागाचे नाव
                  </label>
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    placeholder="उदा. कार्यक्रम, दौरा, सामाजिक उपक्रम"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    required
                  />
                </div>

              </div>

              <div className="mt-4 text-end">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "जतन होत आहे..." : "जतन करा"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default AddGalleryCategory;